import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { getAllBlogs } from "../../store/blogSlice";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const result = await dispatch(getAllBlogs()).unwrap();
        if (result?.documents) {
          setBlogs(result.documents);
        } else {
          setBlogs(result || []);
        }
      } catch (err) {
        console.error("Failed to fetch blogs", err);
        setBlogs([]);
      }
    };
    getBlogData();
  }, [dispatch]);

  return (
    <div className="mt-32">
      <h2 className="text-3xl font-bold text-gray-800 inline-block border-b-4 border-pink-500 pb-2 mb-8">
        Blogs
      </h2>

      {blogs.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20">
          <svg
            className="w-20 h-20 text-gray-400 mb-4"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 17v-6h13v6M4 6h16M4 6v12M4 6l6-6"
            />
          </svg>
          <h3 className="text-xl font-semibold text-gray-600 mb-2">
            Nothing to show
          </h3>
          <p className="text-gray-400 text-center max-w-sm">
            We couldn't find any blogs at the moment. Please check back later.
          </p>
        </div>
      ) : (
        blogs.map((blog) => (
          <div
            key={blog.$id}
            className="border rounded-xl shadow-md my-6 p-6 flex flex-col justify-between hover:shadow-xl transition duration-300 bg-white hover:bg-indigo-50 border-l-4 border-indigo-500 w-full max-w-4xl mx-auto text-left"
          >
            <div>
              <h1 className="text-2xl font-bold text-indigo-700 text-center">
                {blog.Title}
              </h1>
            </div>

            <p
              className="text-gray-700 text-sm mt-3 line-clamp-3"
              dangerouslySetInnerHTML={{ __html: blog.Preview }}
            ></p>

            <div className="flex justify-end mt-4">
              <NavLink
                to={`/blog/${blog.$id}`}
                className="px-4 py-2 bg-indigo-600 text-white text-sm rounded-lg hover:bg-indigo-700 transition"
              >
                Read More
              </NavLink>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Blogs;
